<template>
  <div class="success">
    <global-nav></global-nav>
    <div class="content">
      <p class="icon-wrapper">
        <img src="./success.png" alt="success-icon" width="50" height="50">
      </p>
      <p class="success-text">支付成功!</p>
      <p class="hint-text" style="color: #ff4d4f; font-size: 22px; margin-top: 20px">教务老师会电话告知具体上课事宜!</p>
      <p class="hint-text" style="color: rgba(0,0,0,.85)">手机号码: 15558067572</p>
      <p class="hint-text" style="color: rgba(0,0,0,.85)">微信扫一扫立即联系</p>
      <img src="./code.jpg" alt="" width="150" style="margin: 0 auto; display: block; margin-top: 20px">
      <div class="order-info" v-if="orderinfoShow">
        <div class="order-left">
          <p class="row">订单号：{{orderinfo.out_trade_no}}</p>
          <p class="row">在线支付：{{orderinfo.paymoney}}</p>
          <p class="row">联系人：{{decodeURIComponent(orderinfo.username)}} {{orderinfo.phone}}</p>
        </div>
        <div class="order-right">
          <p class="row">课程：{{decodeURIComponent(orderinfo.lessonname)}}</p>
          <p class="row">班级：{{decodeURIComponent(orderinfo.classperiodname)}}-{{decodeURIComponent(orderinfo.classname)}} 共{{orderinfo.totalnumber}}课 </p>
          <p class="row">开课时间：{{orderinfo.startdate.substring(0, 10)}} {{orderinfo.starttime.substring(0, 5)}}</p>
        </div>
      </div>
      <div class="btn-wrapper">
        <router-link to="/account" class="btn left">查看课程表</router-link>
        <a href="/" class="btn right">返回首页</a>
      </div>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import globalNav from 'components/globalnav/GlobalNav'
  import footNav from 'components/footnav/FootNav'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        userinfo: (() => loadLocal('userinfo', false))(),
        courseinfo: (() => loadLocal('courseinfo', false))(),
        classinfo: (() => loadLocal('classinfo', false))(),
        orderinfoShow: false,
        orderinfo: null,
      }
    },
    methods: {
      QueryClassUser(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassUser',
            a: 'QueryClassUser',
            id: this.id,
            rid: this.classinfo.rid,
            lessonid: this.courseinfo.id,
            classid: this.classinfo.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.list !== null) {
            this.orderinfoShow = true;
            this.orderinfo = response.list[0];
          } else {
            this.$alert('支付后系统可能会有延迟，请稍后再查询已购买的课程', '提示', {
              confirmButtonText: '确定',
            })
          }

        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      }
    },
    created(){
      this.QueryClassUser();
    },
    components: {
      globalNav,
      footNav
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .success
    padding-top: 60px
    .content
      margin: 50px auto
      padding: 0 75px 30px
      width: 1000px
      border: 1px solid #e4e4e4
      box-sizing border-box
      font-size: 0

      .icon-wrapper
        margin-top: 50px
        height: 50px
        text-align: center
      .success-text
        margin-top: 10px
        font-size: 24px
        color: #3399ff
        height: 36px
        font-weight: bold
        line-height: 36px
        text-align center
      .hint-text
        font-size: 18px
        color: #888
        text-align center
        height: 30px
        line-height: 36px
      .order-info
        margin: 40px 0 50px
        padding: 30px 0
        background #f2f2f2
        overflow hidden
        .order-left
          float: left
          padding-left: 50px
          height: 84px
          width: 424px
          border-right: 1px solid #e4e4e4
          box-sizing border-box
          .row
            margin-bottom: 12px
            font-size: 13px
            color: #555555
            height: 20px
            line-height: 20px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
        .order-right
          float: left
          height: 84px
          padding-left: 40px
          width: 424px
          box-sizing border-box
          .row
            margin-bottom: 12px
            font-size: 13px
            color: #555555
            height: 20px
            line-height: 20px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap

      .btn-wrapper
        margin: 54px auto 0
        height: 40px
        width: 300px
        .btn
          display inline-block
          width: 120px
          height: 40px
          line-height 40px
          text-align center
          font-size: 16px
          border-radius 4px
          box-sizing border-box
        .left
          margin-right: 60px
          background #3399ff
          color: #ffffff
        .right
          border: 1px solid #d7d7d7
          color: #666

</style>



// WEBPACK FOOTER //
// src/page/success/Success.vue